var _style, _defs, _defs2, _path, _path2, _path3, _path4, _defs3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.99 32.52",
    style: {
      enableBackground: "new 0 0 85.99 32.52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000023963867053142674150000003991979750138657205_);fill:#687979;}\n\t.st1{clip-path:url(#SVGID_00000036209759065905351540000010646096855097010841_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_00000079472255055570333980000018438269541256127390_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M14,3h58c2.21,0,4,1.79,4,4v18c0,2.21-1.79,4-4,4H14c-2.21,0-4-1.79-4-4V7C10,4.79,11.79,3,14,3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023971530275172175560000012295917457462939525_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    style: {
      clipPath: "url(#SVGID_00000023971530275172175560000012295917457462939525_)",
      fill: "#687979"
    },
    width: 68,
    height: 28
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000128446402385981027820000000965667642168255410_",
    x: 39,
    y: 5.5,
    width: 37,
    height: 26
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096025130556518124420000004038829510844924330_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128446402385981027820000000965667642168255410_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096025130556518124420000004038829510844924330_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.06,22.5h-1.61V9.7h1.61V22.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.11,12.99l0.04,1.03c0.29-0.38,0.63-0.68,1.02-0.89s0.82-0.32,1.3-0.32c0.39,0,0.74,0.06,1.05,0.19 s0.59,0.33,0.81,0.61c0.22,0.28,0.39,0.64,0.51,1.07c0.12,0.44,0.18,0.97,0.18,1.59v6.23h-1.55v-6.25c0-0.74-0.12-1.27-0.37-1.59 c-0.25-0.31-0.62-0.47-1.12-0.47c-0.39,0-0.73,0.13-1.04,0.39s-0.56,0.59-0.74,1.01v6.91h-1.56v-9.51H46.11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.02,22.5v-8.25h-1.24v-1.26h1.24v-1c0-0.51,0.06-0.96,0.19-1.36c0.13-0.4,0.31-0.73,0.54-1 s0.52-0.47,0.86-0.61c0.34-0.14,0.72-0.21,1.14-0.21c0.31,0,0.62,0.05,0.94,0.15l-0.08,1.32c-0.1-0.02-0.21-0.04-0.34-0.06 s-0.25-0.02-0.37-0.02c-0.42,0-0.75,0.15-0.98,0.46c-0.23,0.31-0.35,0.75-0.35,1.32v1h1.63v1.26h-1.63v8.25H54.02z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.67,17.3c0-0.74,0.1-1.4,0.29-1.96c0.19-0.56,0.45-1.03,0.78-1.4s0.72-0.66,1.16-0.85 c0.45-0.19,0.92-0.29,1.43-0.29c0.52,0,1,0.1,1.45,0.29c0.45,0.19,0.84,0.47,1.17,0.85s0.59,0.84,0.78,1.4 c0.19,0.56,0.29,1.21,0.29,1.96v0.9c0,0.74-0.09,1.39-0.29,1.95c-0.19,0.56-0.45,1.03-0.78,1.4s-0.72,0.66-1.17,0.84 c-0.45,0.19-0.93,0.28-1.44,0.28s-1-0.09-1.45-0.28s-0.84-0.47-1.17-0.84s-0.59-0.84-0.78-1.4c-0.19-0.56-0.29-1.21-0.29-1.95 V17.3z M60.22,18.2c0,0.53,0.05,0.99,0.16,1.38s0.26,0.72,0.45,0.98s0.41,0.46,0.67,0.59c0.26,0.13,0.54,0.2,0.84,0.2 c1.41,0,2.12-1.05,2.12-3.15v-0.9c0-0.52-0.05-0.98-0.16-1.37c-0.11-0.39-0.26-0.72-0.45-0.98c-0.19-0.26-0.42-0.46-0.68-0.6 s-0.54-0.2-0.85-0.2c-0.3,0-0.58,0.07-0.83,0.2s-0.48,0.33-0.67,0.6s-0.34,0.59-0.44,0.98c-0.11,0.39-0.16,0.85-0.16,1.37V18.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000140727172731392768730000014753602030924954499_",
    d: "M23.65,13.95h1.7v-1.7h-1.7V13.95z M24.5,23.3 c-3.75,0-6.8-3.05-6.8-6.8s3.05-6.8,6.8-6.8s6.8,3.05,6.8,6.8S28.25,23.3,24.5,23.3z M24.5,8c-4.69,0-8.5,3.81-8.5,8.5 s3.81,8.5,8.5,8.5s8.5-3.81,8.5-8.5S29.19,8,24.5,8z M23.65,20.75h1.7v-5.1h-1.7V20.75z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183932533315459298190000009835422419374033821_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140727172731392768730000014753602030924954499_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    style: {
      clipPath: "url(#SVGID_00000183932533315459298190000009835422419374033821_)",
      fill: "#FFFFFF"
    },
    width: 19,
    height: 19
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoStatus);
export default __webpack_public_path__ + "static/media/info-status.de8ad3dad5205048a2c72fcc381823fb.svg";
export { ForwardRef as ReactComponent };